export const isAndroidDevice = (userAgent: string) =>
  /Android/i.test(userAgent);

export const isIOSDevice = (userAgent: string) =>
  /iPad|iPhone|iPod/i.test(userAgent);

export const isMobileDevice = (userAgent: string) =>
  /Android|iPhone|BlackBerry|BB|Tizen|Windows Phone/i.test(userAgent);

export const isTabletDevice = (userAgent: string) =>
  /iPad|PlayBook|Kindle/i.test(userAgent);

export const isMobileOrTabletDevice = (userAgent: string) =>
  isMobileDevice(userAgent) || isTabletDevice(userAgent);

// Code inspired by: https://github.com/lancedikson/bowser/blob/master/src/parser-browsers.js
// ORDER MATTERS!!!
export const browserType = (ua: string) => {
  switch (true) {
    case /opera/i.test(ua):
    case /opr\/|opios/i.test(ua):
    case /coast/i.test(ua):
      return 'Opera';

    // IE
    case /msie|trident/i.test(ua):
      return 'Internet Explorer';

    // Edge
    case /\sedg\//i.test(ua):
    case /edg([ea]|ios)/i.test(ua):
      return 'Edge';

    case /firefox|iceweasel|fxios/i.test(ua):
      return 'Firefox';

    case /chrome|crios|crmo/i.test(ua):
      return 'Google Chrome';

    case /safari|applewebkit/i.test(ua):
      return 'Safari';

    default:
      return 'Unknown/Other';
  }
};
